import React from 'react';
import { CalorieSummary } from './components/CalorieSummary';
import { MacroBreakdown } from './components/MacroBreakdown';
import { WeeklyChart } from './components/WeeklyChart';
import { WeekCalendar } from './components/WeekCalendar';
import { weekData, todayData } from './utils/mockData';
export function App() {
  return <div className="min-h-screen bg-gray-900 text-white p-8" data-id="element-0">
      <div className="max-w-7xl mx-auto" data-id="element-1">
        <header className="mb-8" data-id="element-2">
          <h1 className="text-4xl font-bold mb-2" data-id="element-3">Calorie Tracker</h1>
          <p className="text-gray-400" data-id="element-4">
            Track your nutrition and reach your goals
          </p>
        </header>

        <main data-id="element-5">
          <section className="mb-8" data-id="element-6">
            <h2 className="text-2xl font-bold mb-4" data-id="element-7">Today's Summary</h2>
            <CalorieSummary caloriesIn={todayData.caloriesIn} caloriesOut={todayData.caloriesOut} data-id="element-8" />
          </section>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8" data-id="element-9">
            <div className="lg:col-span-1" data-id="element-10">
              <MacroBreakdown protein={todayData.protein} carbs={todayData.carbs} fats={todayData.fats} data-id="element-11" />
            </div>
            <div className="lg:col-span-2" data-id="element-12">
              <WeeklyChart data={weekData} data-id="element-13" />
            </div>
          </div>

          <WeekCalendar data={weekData} data-id="element-14" />
        </main>
      </div>
    </div>;
}